// Copy and option lists for the "Generate with AI" pane, same keys, defaults and
// values as the storefront pane (trustshop-shopify-extension
// src/trustshop-ai-generate-form.module.js). Keep in sync.
export const AI_DEFAULT_LABELS = {
    modal_review_label_review_with_ai: "Generate with AI",
    modal_review_tooltip_review_ai_generation:
        "Let AI help you write a great review! You can edit or regenerate it anytime.",
    ai_generate_title: "Generate with AI",
    ai_intro_subtitle:
        "Just answer a few quick questions, and we’ll help you write a great review in seconds.",
    ai_back_to_form: "Back to Write a review",
    ai_generate_now: "Generate Now",
    ai_retry: "Retry",
    ai_select_review: "Select this review",
    ai_rating_question: "How would you rate your overall experience?",
    ai_focus_question: "What would you like to focus on in your review?",
    ai_focus_product_usage: "Product usage experience",
    ai_focus_customer_service: "Customer service quality",
    ai_focus_delivery: "Delivery speed and condition",
    ai_focus_price: "Price and promotions",
    ai_focus_overall: "Overall shopping experience",
    ai_language_title: "Review language",
    ai_length_title: "How long would you like your review to be?",
    ai_length_short: "Short and sweet (1–2 sentences)",
    ai_length_medium: "Medium (3–5 sentences)",
    ai_length_long: "Long and detailed (6+ sentences)",
    ai_tone_title: "What tone would you like the review to have?",
    ai_tone_friendly: "Friendly and casual",
    ai_tone_professional: "Professional and polite",
    ai_tone_short: "Short and to the point",
    ai_tone_detailed: "Detailed and descriptive",
    ai_preparing: "AI is preparing your review...",
    ai_loading_thinking: "Thinking of the best way to say it...",
    ai_loading_polishing: "Almost done! Just polishing it up...",
    ai_choose_review: "Choose your preferred review",
    ai_option_1: "Option 1",
    ai_option_2: "Option 2",
    ai_option_3: "Option 3",
    ai_option_4: "Option 4",
    ai_result_disclaimer:
        "This review is a suggestion generated by AI using your provided information. You are responsible for reviewing and editing it before final submission.",
    // Not in the setting: the generate-failure message.
    ai_error: "Something went wrong. Please try again.",
};

// `value` is sent verbatim to the AI endpoint, so it stays the English constant.
// Only `key`, the visible label, is translated.
export const FOCUS_OPTIONS = [
    { value: "Product usage experience", key: "ai_focus_product_usage" },
    { value: "Customer service quality", key: "ai_focus_customer_service" },
    { value: "Delivery speed and condition", key: "ai_focus_delivery" },
    { value: "Price and promotions", key: "ai_focus_price" },
    { value: "Overall shopping experience", key: "ai_focus_overall" },
];

export const LENGTH_OPTIONS = [
    { value: "Short and sweet (1–2 sentences)", key: "ai_length_short" },
    { value: "Medium (3–5 sentences)", key: "ai_length_medium" },
    { value: "Long and detailed (6+ sentences)", key: "ai_length_long" },
];

export const TONE_OPTIONS = [
    { value: "Friendly and casual", key: "ai_tone_friendly" },
    { value: "Professional and polite", key: "ai_tone_professional" },
    { value: "Short and to the point", key: "ai_tone_short" },
    { value: "Detailed and descriptive", key: "ai_tone_detailed" },
];

export const DEFAULT_LANGUAGE = "English";

export const LANGUAGE_OPTIONS = [
    "Afrikaans",
    "Akan",
    "Amharic",
    "Arabic",
    "Assamese",
    "Azerbaijani",
    "Belarusian",
    "Bulgarian",
    "Bambara",
    "Bangla",
    "Tibetan",
    "Breton",
    "Bosnian",
    "Catalan",
    "Chechen",
    "Central Kurdish",
    "Czech",
    "Church Slavic",
    "Welsh",
    "Danish",
    "German",
    "Dzongkha",
    "Ewe",
    "Greek",
    "English",
    "Esperanto",
    "Spanish",
    "Estonian",
    "Basque",
    "Persian",
    "Fulah",
    "Finnish",
    "Filipino",
    "Faroese",
    "French",
    "Western Frisian",
    "Irish",
    "Scottish Gaelic",
    "Galician",
    "Gujarati",
    "Manx",
    "Hausa",
    "Hebrew",
    "Hindi",
    "Croatian",
    "Hungarian",
    "Armenian",
    "Interlingua",
    "Indonesian",
    "Igbo",
    "Sichuan Yi",
    "Icelandic",
    "Italian",
    "Japanese",
    "Javanese",
    "Georgian",
    "Kikuyu",
    "Kazakh",
    "Kalaallisut",
    "Khmer",
    "Kannada",
    "Korean",
    "Kashmiri",
    "Kurdish",
    "Cornish",
    "Kyrgyz",
    "Latin",
    "Luxembourgish",
    "Ganda",
    "Lingala",
    "Lao",
    "Lithuanian",
    "Luba-Katanga",
    "Latvian",
    "Malagasy",
    "Māori",
    "Macedonian",
    "Malayalam",
    "Mongolian",
    "Moldavian",
    "Marathi",
    "Malay",
    "Maltese",
    "Burmese",
    "Norwegian (Bokmål)",
    "North Ndebele",
    "Nepali",
    "Dutch",
    "Norwegian Nynorsk",
    "Norwegian",
    "Oromo",
    "Odia",
    "Ossetic",
    "Punjabi",
    "Polish",
    "Pashto",
    "Portuguese",
    "Portuguese (Brazil)",
    "Portuguese (Portugal)",
    "Quechua",
    "Romansh",
    "Rundi",
    "Romanian",
    "Russian",
    "Kinyarwanda",
    "Sanskrit",
    "Sardinian",
    "Sindhi",
    "Northern Sami",
    "Sango",
    "Serbo-Croatian",
    "Sinhala",
    "Slovak",
    "Slovenian",
    "Shona",
    "Somali",
    "Albanian",
    "Serbian",
    "Sundanese",
    "Swedish",
    "Swahili",
    "Tamil",
    "Telugu",
    "Tajik",
    "Thai",
    "Tigrinya",
    "Turkmen",
    "Tongan",
    "Turkish",
    "Tatar",
    "Uyghur",
    "Ukrainian",
    "Urdu",
    "Uzbek",
    "Vietnamese",
    "Volapük",
    "Wolof",
    "Xhosa",
    "Yiddish",
    "Yoruba",
    "Chinese",
    "Chinese (Simplified)",
    "Chinese (Traditional)",
    "Zulu",
];
